import { BLUE_500 } from '@airtel/air-design-system';
export var defaultProps = {
  showTitleSection: true,
  titleSectionProps: {
    hideTopPadding: true,
    hideBottomPadding: true,
    parentCardNoPadding: true,
    withChildrenCardWrapper: true,
    gridColProps: {
      noGutter: true
    },
    gridRowProps: {
      noMargin: true
    },
    gridContainerProps: {
      noMargin: true
    },
    gridTitleColProps: {
      noGutter: true
    }
  },
  dataArray: [{
    title: {
      text: '1. General'
    },
    subTitle: {
      multiText: [{
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus aliquet nibh id iaculis pharetra. Maecenas at leo non ligula congue cursus. Integer rhoncus urna tellus, fermentum ultrices risus finibus quis. In non pretium metus, quis ornare nunc. Phasellus sollicitudin consequat enim, vel ullamcorper tellus laoreet a. Morbi eleifend dictum justo, vel blandit enim euismod quis. Duis auctor sapien at mauris iaculis, nec ultricies ipsum interdum. Aliquam eu est nec nibh tempus posuere eleifend sed ex.'
      }, {
        text: ' view more',
        type: 'body-hyperlink-xs',
        color: BLUE_500
      }]
    }
  }, {
    title: {
      text: '2. Eligibility'
    },
    subTitle: {
      multiText: [{
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus aliquet nibh id iaculis pharetra. Maecenas at leo non ligula congue cursus. Integer rhoncus urna tellus, fermentum ultrices risus finibus quis. In non pretium metus, quis ornare nunc. Phasellus sollicitudin consequat enim, vel ullamcorper tellus laoreet a. Morbi eleifend dictum justo, vel blandit enim euismod quis. Duis auctor sapien at mauris iaculis, nec ultricies ipsum interdum. Aliquam eu est nec nibh tempus posuere eleifend sed ex.'
      }, {
        text: ' view more',
        type: 'body-hyperlink-xs',
        color: BLUE_500
      }]
    }
  }, {
    title: {
      text: '3. How to participate'
    },
    subTitle: {
      multiText: [{
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus aliquet nibh id iaculis pharetra. Maecenas at leo non ligula congue cursus. Integer rhoncus urna tellus, fermentum ultrices risus finibus quis. In non pretium metus, quis ornare nunc. Phasellus sollicitudin consequat enim, vel ullamcorper tellus laoreet a. Morbi eleifend dictum justo, vel blandit enim euismod quis. Duis auctor sapien at mauris iaculis, nec ultricies ipsum interdum. Aliquam eu est nec nibh tempus posuere eleifend sed ex.'
      }, {
        text: ' view more',
        type: 'body-hyperlink-xs',
        color: BLUE_500
      }]
    }
  }]
};